module.exports = __webpack_public_path__ + "img/md.de1a8f4c.svg";